import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../css/sidebar.css";

class Sidebar extends Component {
  render() {
    return (
      <nav
        id="sidebar"
        className={
          this.props.activeSidebar ? "active shadow pt-3" : "shadow pt-3"
        }
      >
        {this.props.userRole === "User" && (
          <ul className="list-unstyled mt-5">
            <li>
              <Link className="nav-link text-white" to="/app/dashboard">
                <i className="fas fa-th-large"></i>{" "}
                <span className="hidden_span">Dashboard</span>
              </Link>
            </li>
          </ul>
        )}
        {this.props.userRole === "Admin" && (
          <ul className="list-unstyled mt-5">
            <li>
              <Link className="nav-link text-white" to="/admin/dashboard">
                <i className="fas fa-th-large"></i>{" "}
                <span className="hidden_span">Dashboard</span>
              </Link>
            </li>
            <li>
              <Link className="nav-link text-white" to="/admin/server">
                <i className="fas fa-server"></i>{" "}
                <span className="hidden_span">Customers</span>
              </Link>
            </li>
            <li>
              <Link className="nav-link text-white" to="/admin/user">
                <i className="fas fa-users"></i>{" "}
                <span className="hidden_span">Users</span>
              </Link>
            </li>
            <li>
              <a href="https://orangeenterprises.azurewebsites.net/webmail/v2/dashboard/PetMessage" className="nav-link text-white">
                <i className="fas fa-envelope"></i>{" "}
                <span className="hidden_span">Messages</span>
              </a>
            </li>
          </ul>
        )}
      </nav>
    );
  }
}
export default Sidebar;

